import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
// import { Zoom } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";

import {
  selectedCell,
  isTest,
  isReviewing,
} from '../../../redux/challengeSlice';

import '../../css/jb-styles.css';

export default function SelectorGrid() {
  const theme = useTheme();
  const [selectorIndex, setSelectorIndex] = useState(null);

  const selectedCellState = useSelector((state) => state.challenge.selectedCell);
  const isReviewingState = useSelector((state) => state.challenge.isReviewing);

  // const [selectorIndex, setSelectorIndex] = useState(selectedCellState);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  let array0 = new Array(6).fill(null);

  useEffect(() => {
    console.log('selector isReviewing: ', isReviewingState);

    if (isReviewingState) {
      // console.log('Clear the selector cell');
      // console.log('Set the selector cell');
      setSelectorIndex(null);

      setTimeout(() => {
        // console.log('Wait here');
        setSelectorIndex(selectedCellState);
      }, 500);

    } else {
      // console.log('FALSE');
    }

  }, [isReviewingState]);

  useEffect(() => {
    // setSelectorIndex(null);
    // setSelectorIndex(selectedCellState);
    for (let i = 0; i < 6; i++) {
      document.getElementById(`selector-column${i}`).style.backgroundColor = 'rgb(229 231 235)';
      document.getElementById(`selector-column${i}`).style.border = 'none';
      document.getElementById(`selector-column${i}`).style.borderWidth = '3px';
    };
  }, []);

  useEffect(() => {
    if (selectedCellState === null) {
      for (let i = 0; i < 6; i++) {
        // if (i == selectorIndex) {
        //   document.getElementById(`selector-column${i}`).style.border = '3px solid #3B4E68';
        //   document.getElementById(`selector-column${i}`).style.backgroundColor = '#FFF';
        // } else {
        document.getElementById(`selector-column${i}`).style.backgroundColor = 'rgb(229 231 235)';
        document.getElementById(`selector-column${i}`).style.border = 'none';
        document.getElementById(`selector-column${i}`).style.borderWidth = '3px';
        // }

      };
    }
  }, [selectedCellState]);


  useEffect(() => {
    // if (selectorIndex === null) {
    // if (selectorIndex === null && isReviewingState === false) {
    //   return;
    // }

    for (let i = 0; i < 6; i++) {
      if (i == selectorIndex) {
        document.getElementById(`selector-column${i}`).style.border = '3px solid #3B4E68';
        document.getElementById(`selector-column${i}`).style.backgroundColor = '#FFF';
      } else {
        document.getElementById(`selector-column${i}`).style.backgroundColor = 'rgb(229 231 235)';
        document.getElementById(`selector-column${i}`).style.border = 'none';
        document.getElementById(`selector-column${i}`).style.borderWidth = '3px';
      }

    };

  }, [selectorIndex]);

  const selectorHandler = (columnIndex) => {

    // selectedCell == null || columnIndex == selectorIndex



    setSelectorIndex(columnIndex);
    dispatch(selectedCell(columnIndex));
  };

  return (
    <React.Fragment>
      {/*   <Box>
        <Typography variant='body1'
          sx={{
            fontSize: '0.8em',
            color: '#3B4E68',
          }}
        >
          Choose your selector cell position
        </Typography>

      </Box> */}

      <Box
        id='selector-grid-container'
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          // marginLeft: '10px',
          // marginRight: '10px',
          padding: '20px',
          paddingBottom: '10px',
          // paddingBottom: '0px',
          paddingTop: '10px',
          marginTop: '10px',
          width: '100%',
          alignSelf: 'center',
          cursor: `url('/sites/default/files/media/image/circle2.svg'), auto`,
          backgroundColor: 'rgb(156, 163, 175)',
          // borderRadius: '10px',
        }}
      >

        {array0.map((col, columnIndex) => (
          // <Box
          //   key={`grid-row${columnIndex}`}
          //   id={`grid-row${columnIndex}`}
          //   sx={{
          //     display: 'flex',
          //     justifyContent: 'space-between',
          //     marginBottom: '5px',
          //   }}>
          <Box
            key={`selector-column${columnIndex}`}
            id={`selector-column${columnIndex}`}
            className={`jb-cell selector-card jb-border-200`}
            sx={{
              // padding: '10px',
              width: '15%',
              aspectRatio: '1 / 1',
              color: '#3B4E68',
              // borderStyle: 'outset',
              cursor: 'pointer',
              borderWidth: '3px',
              // borderColor: 'rgb(229 231 235)',
              // backgroundColor: 'rgb(229 231 235)',
              // backgroundColor: {selectorIndex == columnIndex ? 'rgb(146 229 156)' : 'rgb(229 231 235)'},
            }}
            onClick={() => { selectorHandler(columnIndex) }}
          >
            {<FiberManualRecordIcon />}
          </Box>
          // </Box>
        ))
        }

      </Box >



    </React.Fragment >
  );
}      
